<template>
  <div class="page-content">
    <!-- <p class="newMine_pageTitle">修改密码</p> -->
     <p class="newMine_pageTitle newMine_pageTitleb m-b10">
      <span class="newMine_pageTitles">修改密码</span>
    </p>
    <div class="newMine_content d-flex-btn">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="原密码" prop="password">
          <el-input v-model="ruleForm.password"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword1">
          <el-input v-model="ruleForm.newPassword1"></el-input>
        </el-form-item>
        <!-- <el-form-item style="margin-bottom: 30px;">
          <div class="input_span">
            <span
              :style="{ 'background-color': (msgText > 1 || msgText == 1) ? '#FC5F76' : '#BBBBBB', 'color': (msgText > 1 || msgText == 1) ? '#FC5F76' : '#BBBBBB' }">弱</span>
            <span
              :style="{ 'background-color': (msgText > 2 || msgText == 2) ? '#FF9900' : '#BBBBBB', 'color': (msgText > 2 || msgText == 2) ? '#FF9900' : '#BBBBBB' }">中</span>
            <span
              :style="{ 'background-color': (msgText > 4 || msgText == 4) ? '#33CC00' : '#BBBBBB', 'color': (msgText > 4 || msgText == 4) ? '#33CC00' : '#BBBBBB' }">强</span>
          </div>
        </el-form-item> -->
        <el-form-item label="确认密码" prop="newPassword">
          <el-input v-model="ruleForm.newPassword"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"

export default {
  components: {
  },
  name: "editPw",
  data() {
    return {
      loading: false,
      msgText: '',
      ruleForm: {
        password: '',
        newPassword1: '',
        newPassword: '',
      },
      rules: {
        password: [
          { required: true, message: '请输入原密码', trigger: 'blur' },
        ],
        newPassword1: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
        ],
      }
    };
  },
  computed: {
    ...mapState(['user'])
  },
  watch: {
    'ruleForm.newPassword1': {
      handler(keyWord, oldname) {
        this.msgText = this.checkStrong(keyWord);
      }
    }
  },
  async mounted() {

  },
  methods: {
    checkStrong(sValue) {
      var modes = 0;
      //正则表达式验证符合要求的
      if (sValue.length < 1) return modes;
      if (/\d/.test(sValue)) modes++; //数字
      if (/[a-z]/.test(sValue)) modes++; //小写
      if (/[A-Z]/.test(sValue)) modes++; //大写
      if (/\W/.test(sValue)) modes++; //特殊字符
      //逻辑处理
      switch (modes) {
        case 1:
          return 1;
          break;
        case 2:
          return 2;
          break;
        case 3:
        case 4:
          return sValue.length < 4 ? 3 : 4;
          break;
      }
      return modes;
    },
    submitForm(formName) {
      const _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(_this.ruleForm.newPassword1!=_this.ruleForm.newPassword){
            _this.$message.error('两次输入密码不一致')
            return
          }
          _this.$http.post('/student/pc/personal/password', _this.ruleForm).then(res => {
            _this.$message.success('操作成功！')
            _this.ruleForm = {
              password: '',
              newPassword1: '',
              newPassword: '',
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }

  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-form {
  width: 50%;
}

.newMine_pageTitle {
  height: 80px;
  line-height: 80px;
  box-sizing: border-box;
  padding: 0 30px;
  font-weight: bold;
  font-size: 18px;
  color: #333;
}

.newMine_content {
  padding: 0 30px;
}

.input_span {
  height: 8px;
  display: flex;
  // float: right;
  width: 35%;

  span {
    display: inline-block;
    width: 30%;
    border-radius: 8px;
    margin-right: 3px;
    text-align: center;
    margin-top: 3px;
  }
}
</style>
